'use strict';

require('./modernizr');

require('./handlebars');

require('./ajax-cart');

require('./jquery.currencies.min');

require('./includes-polyfill');